import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { postProyecto } from '../../services/apis';
import {
    Alert, Autocomplete, Button, Checkbox, Dialog, DialogActions, DialogContent,
    DialogContentText, DialogTitle, FormControlLabel, Grid, IconButton, InputAdornment,
    InputBase, Paper, Snackbar, TextField
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { AlertError } from '../../utils/componentes-utiles/AlertError';




export const FormCrearProyecto = ({ open, setOpen, cargarProyectos, opciones, setOpciones }) => {

    const handleClose = () => {
        setOpen(false);
    };
    const param = useParams();
    const [errorAlert, setErrorAlert] = useState(false);
    const [clienteSelec, setClienteSelec] = useState({ label: "Seleccione un Cliente", value: "0" });
    const [trabajadorSelec, setTrabajadorSelec] = useState([]);
    const [proyecto, setProyecto] = useState({
        'fecha': new Date(),
        'titulo': '',
        'descripcion': '',
        'id_cliente': null,
        'opciones': []
    });
    // const [opclientes, setOpclientes] = useState([]);
    const handleChange = (event) => {
        const proyectoNuevo = { ...proyecto, [event.target.name]: event.target.value };
        setProyecto(proyectoNuevo);
        setErrorAlert(false)
    };
    useEffect(() => {
        setOpciones(prevOpciones => 
            prevOpciones.map(opcion => ({ ...opcion, checked: opcion.checked == 1 }))
        );


    }, []);
    


    const isNullInObject = (obj) => {
        // Lista de campos que se deben omitir en la validación
        const camposExcepcion = ['id_cliente', 'trabajadores', 'opciones'];

        return Object.keys(obj).every(key => {
            if (camposExcepcion.includes(key)) {
                return true;
            }
            return obj[key] !== null && obj[key] !== '' && obj[key] != 0;
        });
    };
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;

        // Actualiza el estado correctamente, creando una nueva copia del array
        setOpciones((prevOpciones) =>
            prevOpciones.map((opcion) =>
                opcion.nombre === name ? { ...opcion, checked } : opcion // Solo actualiza la opción correspondiente
            )
        );
    };
    const crearProyecto = async () => {
        console.log("opciones", opciones);
        const nuevoProyecto = { ...proyecto };
        nuevoProyecto.id_cliente = clienteSelec.value;
        nuevoProyecto.trabajadores = trabajadorSelec;
        // if (opciones.length >= 1) {
        //     nuevoProyecto.opciones = opciones.filter(opcion => opcion.checked == true ).map(opcion => opcion.id);

        // }
        if(opciones.length >= 1 ){
            nuevoProyecto.opciones  = opciones;
            
        }
        const proyectoComprobado = isNullInObject(nuevoProyecto);

        if (!proyectoComprobado) {
            console.error("Hay campos vacíos o no válidos en el proyecto");
            setErrorAlert(true);

            return; // Detener la ejecución si hay campos no válidos
        }

        try {
            const response = await postProyecto(nuevoProyecto);
            if (response.success === true) {
                handleClose();

                cargarProyectos();
                setProyecto(
                    {
                        'fecha': new Date(),
                        'titulo': '',
                        'descripcion': '',
                        'id_cliente': null
                    });
                setClienteSelec({ label: "Seleccione un Cliente", value: "0" });
                setTrabajadorSelec([]);
                handleClose();

            }
        } catch (error) {
            console.error("Error al cargar proyectos", error);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        crearProyecto();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="form-dialog-title"
            aria-describedby="form-dialog-description"
        >
            <DialogTitle id="form-dialog-title">
                Crear Nuevo Proyecto
            </DialogTitle>

            <DialogContent >
                <div className='flex-right'>
                    <CancelIcon onClick={handleClose} style={{ cursor: 'pointer' }} />
                </div>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2} direction="column">
                        {/* <Grid item>
                            <Autocomplete
                                className={opclientes ? "inputDateInput" : 'inputDateInput-empty'}
                                disablePortal
                                id="combo-box-demo"
                                options={opclientes}
                                sx={{ width: 300 }}
                                value={clienteSelec}
                                onChange={(event, newValue) => setClienteSelec(newValue)}
                                renderInput={(params) => <TextField {...params} label="Obligatorio*" />}
                            />
                        </Grid> */}
                        {/* <Grid item>
                            <AutocompleteList array={opTrabajadores} setArray={setTrabajadorSelec} />
                        </Grid> */}
                        <Grid item>
                            <TextField
                                label="Titulo"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="titulo"
                                value={proyecto.titulo}
                                onChange={handleChange}
                                required
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                label="Descripcion"
                                variant="outlined"
                                multiline
                                fullWidth
                                name="descripcion"
                                value={proyecto.descripcion}
                                onChange={handleChange}
                                required
                            />
                        </Grid>
                        <Grid item>

                            {opciones.length >= 1 && (
                                opciones.map((opcion) => (
                                    <FormControlLabel
                                        key={opcion.id}
                                        control={
                                            <Checkbox
                                                onChange={handleCheckboxChange}
                                                name={opcion.nombre}
                                                checked={opcion.checked == 1 ? true : false}
                                            />
                                        }
                                        label={opcion.nombre}
                                    />
                                ))
                            )}
                        </Grid>

                    </Grid>

                </form>
            </DialogContent>

            <DialogActions style={{

            }}>
                <Button onClick={handleClose} color="primary">
                    Cancelar
                </Button>
                <Button onClick={handleSubmit} color="primary" variant="contained">
                    Crear Proyecto
                </Button>
            </DialogActions>
            {errorAlert && (
                <AlertError open={errorAlert} setOpen={setErrorAlert} titulo={"Error"} mensaje={"Falta rellenar algún campo obligatorio"} />
            )}
        </Dialog>
    );
};
